import {
	ADMINADDORUPDATELOYALTYPOINT_SUCCESS,
	ADMINADDORUPDATELOYALTYPOINT_FAILED,
	RESET_ADMINADDORUPDATELOYALTYPOINT,
	LOADING_ADMINADDORUPDATELOYALTYPOINT,
	NETWORK_ERROR_ADMINADDORUPDATELOYALTYPOINT
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetAdminAddOrUpdateLoyaltyPoint = () => {
	return { type: RESET_ADMINADDORUPDATELOYALTYPOINT };
};

const adminAddOrUpdateLoyaltyPoint =
	(userData, authTokenIs) => async (dispatch) => {
		dispatch({ type: LOADING_ADMINADDORUPDATELOYALTYPOINT });
		await partnerServices
			.post("createOrUpdateLoyaltyPoint", userData, { headers: { AuthToken: authTokenIs } })
			.then((res) => {
				switch (res.data.status) {
					case "success":
						dispatch(adminAddOrUpdateLoyaltyPointsuccess(res.data));
						break;
					default:
						dispatch(adminAddOrUpdateLoyaltyPointFailed(res.data));
						break;
				}
			})
			.catch((err) => {
				dispatch({
					type: NETWORK_ERROR_ADMINADDORUPDATELOYALTYPOINT,
					payload: err
				});
			});
	};
function adminAddOrUpdateLoyaltyPointsuccess(data) {
	return {
		type: ADMINADDORUPDATELOYALTYPOINT_SUCCESS,
		payload: data
	};
}
function adminAddOrUpdateLoyaltyPointFailed(data) {
	return {
		type: ADMINADDORUPDATELOYALTYPOINT_FAILED,
		payload: data
	};
}

export { resetAdminAddOrUpdateLoyaltyPoint, adminAddOrUpdateLoyaltyPoint };
